/* Patagonia Café — Nos cafés (mobile) : filtres, 15-10-2026.
   Au-dessus du catalogue mobile (.pcm-page) : un bouton « Filtrer » et le nombre
   de cafés ; tous les critères sont dans le volet du bas (gamme, puissance).
   Les cartes sont réellement déplacées dans la page : les cafés choisis passent
   devant, les autres restent dessous sous une ligne qui les annonce. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  var DATA = {
    'sol andino': { range: 'selection', intensity: 3 },
    'signature': { range: 'selection', intensity: 4 },
    'patagonia': { range: 'selection', intensity: 4 },
    'espresso': { range: 'selection', intensity: 5 },
    'brasil': { range: 'specialite', intensity: 4 },
    'colombia': { range: 'specialite', intensity: 3 },
    'honduras': { range: 'specialite', intensity: 2 }
  };

  var RANGE = { key: 'range', label: 'Gamme', options: [
    { id: 'selection', label: 'Cafés de sélection', test: function (d) { return d.range === 'selection'; } },
    { id: 'specialite', label: 'Cafés de spécialité', test: function (d) { return d.range === 'specialite'; } }
  ] };

  var POWER = { key: 'intensity', label: 'Puissance', options: [
    { id: 'doux', label: 'Doux', gauge: 3, test: function (d) { return d.intensity <= 3; } },
    { id: 'intense', label: 'Intense', gauge: 4, test: function (d) { return d.intensity === 4; } },
    { id: 'puissant', label: 'Puissant', gauge: 5, test: function (d) { return d.intensity >= 5; } }
  ] };

  var GROUPS = [RANGE, POWER];

  var CSS = [
    '.pcmf,.pcmf__row{display:none}',
    '@media (max-width:749px){',
    '.pcmf{display:block;padding:14px 16px 10px;background:#f8f2e8;font-family:"Work Sans",Arial,sans-serif}',
    '.pcmf *{box-sizing:border-box}',
    '.pcmf__top{display:flex;align-items:center;justify-content:space-between;gap:12px}',
    '.pcmf__trigger{display:inline-flex;align-items:center;gap:8px;min-height:42px;padding:0 16px;border:1.5px solid #172943;border-radius:999px;background:#fffdf9;color:#172943;font:600 13.5px/1 "Work Sans",Arial,sans-serif;cursor:pointer}',
    '.pcmf__trigger svg{width:16px;height:16px;flex:0 0 16px}',
    '.pcmf__badge{display:inline-flex;align-items:center;justify-content:center;min-width:19px;height:19px;padding:0 5px;border-radius:999px;background:#b95319;color:#fffdf9;font-size:11px;font-weight:700}',
    '.pcmf__count{margin:0;color:#6a7585;font-size:13px;font-weight:500;white-space:nowrap}',
    '.pcmf__chip{display:inline-flex;align-items:center;gap:9px;min-height:40px;padding:0 15px;border:1px solid #dccbb5;border-radius:999px;background:#fffaf3;color:#172943;font:500 13.5px/1 "Work Sans",Arial,sans-serif;white-space:nowrap;cursor:pointer}',
    '.pcmf__chip[aria-pressed="true"]{border-color:#172943;background:#172943;color:#f8f2e8;font-weight:600}',
    '.pcmf__gauge{display:inline-flex;align-items:center;gap:3px}',
    '.pcmf__gauge i{display:block;width:9px;height:7px;border-radius:2px;background:#e2d2bb}',
    '.pcmf__gauge i.on{background:#b95319}',
    '.pcmf__chip[aria-pressed="true"] .pcmf__gauge i{background:rgba(248,242,232,.28)}',
    '.pcmf__chip[aria-pressed="true"] .pcmf__gauge i.on{background:#e6ae83}',
    '.pcmf__backdrop{position:fixed;inset:0;z-index:9998;background:rgba(16,29,49,.5)}',
    '.pcmf__sheet{position:fixed;left:0;right:0;bottom:0;z-index:9999;max-height:86vh;overflow:auto;padding:8px 18px calc(18px + env(safe-area-inset-bottom));border-radius:22px 22px 0 0;background:#fffdf9;box-shadow:0 -14px 40px rgba(16,29,49,.28)}',
    '.pcmf__grab{width:44px;height:4px;margin:6px auto 12px;border-radius:999px;background:#e2d8c9}',
    '.pcmf__sheet h2{margin:0 0 4px;font-family:"Playfair Display",Georgia,serif;font-size:24px;font-weight:600;color:#172943;letter-spacing:-.015em}',
    '.pcmf__sheet > p{margin:0 0 16px;color:#6a7585;font-size:13.5px;line-height:1.45}',
    '.pcmf__group{padding:14px 0;border-top:1px solid #efe6d8}',
    '.pcmf__group h3{margin:0 0 10px;font:700 11.5px/1.4 "Work Sans",Arial,sans-serif;letter-spacing:.14em;text-transform:uppercase;color:#b95319}',
    '.pcmf__row-chips{display:flex;flex-wrap:wrap;gap:8px}',
    '.pcmf__hint{margin:8px 0 0;color:#6a7585;font-size:12.5px;line-height:1.45}',
    '.pcmf__foot{position:sticky;bottom:0;display:flex;align-items:center;gap:14px;padding:14px 0 4px;background:linear-gradient(rgba(255,253,249,0),#fffdf9 22%)}',
    '.pcmf__reset{flex:0 0 auto;padding:10px 0;border:0;background:transparent;color:#172943;font:600 13.5px/1 "Work Sans",Arial,sans-serif;text-decoration:underline;text-underline-offset:4px}',
    '.pcmf__apply{flex:1 1 auto;min-height:50px;border:0;border-radius:999px;background:#b95319;color:#fffdf9;font:600 15px/1 "Work Sans",Arial,sans-serif;box-shadow:0 8px 20px rgba(185,83,25,.22)}',
    '.pcmf__row{display:block;grid-column:1/-1;margin:2px 0 0;padding:14px 0 2px;border-top:1px solid #e2d8c9;color:#6a7585;font:500 12.5px/1.45 "Work Sans",Arial,sans-serif}',
    '.pcmf__row b{display:block;color:#172943;font-family:"Playfair Display",Georgia,serif;font-size:18px;font-weight:600;line-height:1.2;margin-bottom:3px}',
    '.pcmf-hide{display:none!important}',
    'html body .pcm-page .pcm-stage-wrap{min-height:0!important;height:auto!important;overflow:visible!important}',
    'html body .pcm-page .pcm-stage{height:auto!important;min-height:0!important;position:static!important;align-items:stretch!important;align-content:start!important}',
    'html body .pcm-page .pcm-stage > .pcm-card{position:relative!important;inset:auto!important;transform:none!important;opacity:1!important;height:auto!important}',
    'html body .pcm-page .pcm-special-grid{align-content:start!important}',
    '}'
  ].join('');

  var FUNNEL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5h18l-7 8v5l-4 2v-7z"/></svg>';

  var state = { range: [], intensity: [] };
  var root, badge, count, sheet, backdrop, applyBtn, grids = [], total = 0;

  function profileOf(card) {
    var title = (card.querySelector('.pcm-card-title') || {}).textContent || '';
    return DATA[title.trim().toLowerCase()] || null;
  }

  function hits(group, d) {
    var picked = state[group.key];
    if (!picked.length || !d) return true;
    for (var i = 0; i < group.options.length; i++) {
      if (picked.indexOf(group.options[i].id) > -1 && group.options[i].test(d)) return true;
    }
    return false;
  }

  function otherTitle() {
    var p = state.intensity;
    if (p.length !== 1) return 'Les autres cafés de la carte';
    if (p[0] === 'doux') return 'Les autres cafés, plus intenses';
    if (p[0] === 'puissant') return 'Les autres cafés, plus doux';
    return 'Les autres cafés, plus doux ou plus puissants';
  }

  function apply() {
    var power = state.intensity.length > 0;
    var chosen = 0;
    var shown = 0;

    grids.forEach(function (grid) {
      var first = [], later = [], out = [];
      grid.cards.forEach(function (card) {
        var d = card.__pcmfProfile;
        if (!hits(RANGE, d)) { card.classList.add('pcmf-hide'); out.push(card); return; }
        card.classList.remove('pcmf-hide');
        shown++;
        if (!power || hits(POWER, d)) { first.push(card); chosen++; } else { later.push(card); }
      });

      /* On déplace réellement les cartes : aucun trou, aucun ordre fantôme. */
      first.forEach(function (c) { grid.el.appendChild(c); });
      grid.el.appendChild(grid.row);
      later.forEach(function (c) { grid.el.appendChild(c); });
      out.forEach(function (c) { grid.el.appendChild(c); });

      var show = power && first.length > 0 && later.length > 0;
      grid.row.classList.toggle('pcmf-hide', !show);
      if (show) {
        grid.row.innerHTML = '<b>' + otherTitle() + '</b>Ils restent disponibles, simplement plus loin de ce que vous avez choisi.';
      }
      if (grid.section) grid.section.classList.toggle('pcmf-hide', first.length + later.length === 0);
    });

    var n = state.range.length + state.intensity.length;
    badge.textContent = n;
    badge.hidden = n === 0;
    count.textContent = power
      ? chosen + (chosen > 1 ? ' cafés en tête' : ' café en tête')
      : shown + (shown > 1 ? ' cafés' : ' café');
    if (applyBtn) {
      applyBtn.textContent = power
        ? (chosen > 1 ? 'Voir les ' + chosen + ' cafés' : 'Voir le café')
        : 'Voir les ' + shown + ' cafés';
    }
    [].forEach.call(sheet.querySelectorAll('[data-pcmf-opt]'), function (btn) {
      var on = state[btn.getAttribute('data-pcmf-group')].indexOf(btn.getAttribute('data-pcmf-opt')) > -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function toggle(group, id) {
    var list = state[group];
    var at = list.indexOf(id);
    if (at > -1) list.splice(at, 1); else list.push(id);
    apply();
  }

  function reset() {
    state.range = [];
    state.intensity = [];
    apply();
  }

  function scrollToResults() {
    if (!root) return;
    var y = window.pageYOffset + root.getBoundingClientRect().top - 96;
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
  }

  /* Dans l'editeur de theme, Shopify intercepte les clics sur les sections :
     on ecoute alors pointerup, qui lui passe. Ailleurs, un simple clic. */
  var EDITOR = !!(window.Shopify && window.Shopify.designMode);
  function bind(el, fn) {
    el.addEventListener(EDITOR ? 'pointerup' : 'click', function (e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      fn();
    }, EDITOR);
  }

  function chip(groupKey, opt) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pcmf__chip';
    if (opt.gauge) {
      var g = document.createElement('span');
      g.className = 'pcmf__gauge';
      g.setAttribute('aria-hidden', 'true');
      for (var i = 1; i <= 5; i++) {
        var bar = document.createElement('i');
        if (i <= opt.gauge) bar.className = 'on';
        g.appendChild(bar);
      }
      b.appendChild(g);
    }
    var t = document.createElement('span');
    t.textContent = opt.label;
    b.appendChild(t);
    b.setAttribute('data-pcmf-group', groupKey);
    b.setAttribute('data-pcmf-opt', opt.id);
    b.setAttribute('aria-pressed', 'false');
    bind(b, function () { toggle(groupKey, opt.id); });
    return b;
  }

  function openSheet() {
    backdrop.hidden = false;
    sheet.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    root.querySelector('.pcmf__trigger').setAttribute('aria-expanded', 'true');
  }

  function closeSheet() {
    backdrop.hidden = true;
    sheet.hidden = true;
    document.documentElement.style.overflow = '';
    root.querySelector('.pcmf__trigger').setAttribute('aria-expanded', 'false');
  }

  function build() {
    var page = document.querySelector('.pcm-page');
    var selection = page && page.querySelector('.pcm-selection');
    if (!page || !selection || document.querySelector('.pcmf')) return;

    grids = [];
    total = 0;
    [['.pcm-stage', '.pcm-selection'], ['.pcm-special-grid', '.pcm-special']].forEach(function (pair) {
      var el = page.querySelector(pair[0]);
      if (!el) return;
      var cards = [].slice.call(el.querySelectorAll('.pcm-card'));
      if (!cards.length) return;
      cards.forEach(function (c) { c.__pcmfProfile = profileOf(c); });
      var row = document.createElement('p');
      row.className = 'pcmf__row pcmf-hide';
      el.appendChild(row);
      grids.push({ el: el, cards: cards, row: row, section: page.querySelector(pair[1]) });
      total += cards.length;
    });
    if (!total) return;

    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    root = document.createElement('section');
    root.className = 'pcmf';
    root.setAttribute('aria-label', 'Filtrer les cafés');

    var top = document.createElement('div');
    top.className = 'pcmf__top';
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'pcmf__trigger';
    trigger.setAttribute('aria-expanded', 'false');
    trigger.innerHTML = FUNNEL + '<span>Filtrer</span>';
    badge = document.createElement('span');
    badge.className = 'pcmf__badge';
    badge.hidden = true;
    trigger.appendChild(badge);
    bind(trigger, openSheet);
    count = document.createElement('p');
    count.className = 'pcmf__count';
    top.appendChild(trigger);
    top.appendChild(count);
    root.appendChild(top);

    backdrop = document.createElement('div');
    backdrop.className = 'pcmf__backdrop';
    backdrop.hidden = true;
    bind(backdrop, closeSheet);

    sheet = document.createElement('div');
    sheet.className = 'pcmf__sheet';
    sheet.hidden = true;
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML = '<div class="pcmf__grab"></div><h2>Trouver votre café</h2><p>Choisissez votre gamme et la puissance que vous aimez.</p>';
    GROUPS.forEach(function (g) {
      var block = document.createElement('div');
      block.className = 'pcmf__group';
      var h = document.createElement('h3');
      h.textContent = g.label;
      var row = document.createElement('div');
      row.className = 'pcmf__row-chips';
      g.options.forEach(function (o) { row.appendChild(chip(g.key, o)); });
      block.appendChild(h);
      block.appendChild(row);
      if (g === POWER) {
        var hint = document.createElement('p');
        hint.className = 'pcmf__hint';
        hint.textContent = 'Les cafés de cette puissance passent en tête ; les autres restent affichés juste en dessous.';
        block.appendChild(hint);
      }
      sheet.appendChild(block);
    });
    var foot = document.createElement('div');
    foot.className = 'pcmf__foot';
    var resetBtn = document.createElement('button');
    resetBtn.type = 'button';
    resetBtn.className = 'pcmf__reset';
    resetBtn.textContent = 'Tout effacer';
    bind(resetBtn, reset);
    applyBtn = document.createElement('button');
    applyBtn.type = 'button';
    applyBtn.className = 'pcmf__apply';
    bind(applyBtn, function () { closeSheet(); scrollToResults(); });
    foot.appendChild(resetBtn);
    foot.appendChild(applyBtn);
    sheet.appendChild(foot);

    selection.parentNode.insertBefore(root, selection);
    document.body.appendChild(backdrop);
    document.body.appendChild(sheet);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) closeSheet();
    });

    apply();
  }

  function start() {
    if (!window.matchMedia || !window.matchMedia(MOBILE).matches) return;
    build();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  if (window.matchMedia) {
    var mq = window.matchMedia(MOBILE);
    var onChange = function () { if (mq.matches) build(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }
})();
